import { DropdownType } from 'src/types/types';
import { create } from 'zustand';

interface Props {
  data: DropdownType[];
  defaultValue: DropdownType | null;

  setNationality: (data: any) => void;
}
export const useNationalityState = create<Props>(set => ({
  data: [],
  defaultValue: null,
  setNationality: data => set(state => ({ ...state, ...data })),
}));
